export const constructionProject = {
  refreshToolTip: '下拉刷新',
  loadingToolTip: '上拉加载更多',
  looseToolTip: '释放刷新',
  pullToolTip: '上拉操作',
  loose2LoadingToolTip: '释放加载更多',
  pull2LoadingToolTip: '上拉加载更多',
  loading: '加载中'
}
